// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CalendarNameBadge__container___lm5th {
    opacity: 0.7;
}

.CalendarNameBadge__calendarName___WOWGd {
    font-size: 12px;
    font-style: italic;
    color: white;
    padding: 0px 5px;;
}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CalendarNameBadge__container___lm5th`,
	"calendarName": `CalendarNameBadge__calendarName___WOWGd`
};
module.exports = ___CSS_LOADER_EXPORT___;
